export default {
  GET_ALL: `#graphql
  query getSaleDates {
    getSaleDates {
      brand,
      initialDate,
      endDate,
      name
    }
  }`,

  UPDATE: `#graphql
  mutation updateSaleDates($brand: String!, $initialDate: String!, $endDate: String!, $name: String!) {
    updateSaleDates(brand: $brand, initialDate: $initialDate, endDate: $endDate, name: $name)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/saleDates.js